var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 8,
    viewBox: "0 0 7 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 0.8C4.39133 0.8 6.06667 2.236 6.06667 4C6.06667 5.764 4.39133 7.2 2.33333 7.2C2.17467 7.2 2.016 7.192 1.862 7.172C2.75333 6.308 3.26667 5.18 3.26667 4C3.26667 2.82 2.75333 1.692 1.862 0.828C2.016 0.808 2.17467 0.8 2.33333 0.8ZM2.33333 0C1.484 0 0.686 0.2 0 0.54C1.39533 1.232 2.33333 2.52 2.33333 4C2.33333 5.48 1.39533 6.768 0 7.46C0.686 7.8 1.484 8 2.33333 8C4.90933 8 7 6.208 7 4C7 1.792 4.90933 0 2.33333 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDark);
export default __webpack_public_path__ + "static/media/dark.7e906acfaaadb5f3301db8a7f6dd161a.svg";
export { ForwardRef as ReactComponent };